import { styled } from '@linaria/react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronIcon } from '@vidbaseapp/styleguide';
import { useState } from 'react';
import clsx from 'clsx';
const spring = {
  type: 'spring',
  stiffness: 500,
  damping: 30
};
export const StyledHeaderNav = /*#__PURE__*/styled(motion.nav)({
  name: "StyledHeaderNav",
  class: "s1nz4i4"
});
export const Underline = () => {
  return <motion.div className="underline" layoutId="underline" // layout
  initial={false} animate={{
    left: 0
  }} // animate={{ left: '0px', right: '0px', bottom: '-1px' }}
  transition={spring} // initial={{ left: '25%', right: '25%', bottom: '-2px' }}
  // animate={{ left: '0px', right: '0px', bottom: '-1px' }}
  // transition={{ easing: spring() }}
  ></motion.div>;
};
export const StyledSubMenuItems = /*#__PURE__*/styled("div")({
  name: "StyledSubMenuItems",
  class: "se9jedg"
});
const SubMenuItemsVariants = {
  hidden: {
    opacity: 1,
    left: '-50%'
  },
  visible: {
    opacity: 1,
    left: '-50%',
    transition: {
      delayChildren: 0.1,
      staggerChildren: 0.05
    }
  },
  exit: {
    opacity: 0,
    transformOrigin: '50% -50px',
    transform: 'rotateX(-50deg)'
  }
};
export const SubMenuItems = ({
  children,
  ...props
}) => {
  return <StyledSubMenuItems {...props}>
			<motion.div className="menu-flyout" layoutId="menu" variants={SubMenuItemsVariants} style={{
      minWidth: '200px'
    }} initial="hidden" animate="visible" transition={spring} exit="exit">
				<div className="flyout-arrow"></div>
				<div className="flyout-arrow-shadow"></div>
				<div className="flyout-content">{children}</div>
			</motion.div>
		</StyledSubMenuItems>;
};
export const StyledMenuItem = /*#__PURE__*/styled(motion.div)({
  name: "StyledMenuItem",
  class: "sgtbiul"
});
export const MenuItem = ({
  children = null,
  href = null,
  value,
  ...props
}) => {
  const [isHovering, setIsHovering] = useState(false);
  return <StyledMenuItem {...props} onHoverStart={() => {
    setIsHovering(true);
  }} onHoverEnd={() => {
    setIsHovering(false);
  }}>
			<span className="nav-menu-item">
				<a href={href} className={clsx('nav-menu-label', {
        glowing: isHovering
      })}>
					{value}
					{children && <ChevronIcon size="1rem" hasGlow={isHovering} color={isHovering ? 'var(--clr-white)' : 'var(--clr-text)'} />}
				</a>
				{isHovering && <Underline />}
			</span>

			{children && <AnimatePresence>{isHovering && <SubMenuItems>{children}</SubMenuItems>}</AnimatePresence>}
		</StyledMenuItem>;
};
export const HeaderNav = ({ ...props
}) => {
  return <StyledHeaderNav {...props}>
			{
      /* <AnimateSharedLayout> */
    }
			<MenuItem value={'Use Cases'} href="#">
				<SubMenuItem>
					<a href="/use-cases/podcasts" title="Use Case: Podcasters">
						<span className="icon">🎙️</span>
						<span className="label-container">
							<span className="label">Podcasters</span>
							<span className="desc">Audio-only podcasts, interviews, and chats.</span>
						</span>
					</a>
				</SubMenuItem>
				<SubMenuItem>
					<a href="/use-cases/youtube">
						<span className="icon">📺</span>
						<span className="label-container">
							<span className="label">YouTubers</span>
							<span className="desc">Video essays, talking heads, tutorials, etc.</span>
						</span>
					</a>
				</SubMenuItem>
				<SubMenuItem>
					<a href="/use-cases/marketing">
						<span className="icon">💸</span>
						<span className="label-container">
							<span className="label">Marketers</span>
							<span className="desc">Video advertisements, real-estate, etc.</span>
						</span>
					</a>
				</SubMenuItem>
				<SubMenuItem>
					<a href="/use-cases/photography">
						<span className="icon">📸</span>
						<span className="label-container">
							<span className="label">Photographers</span>
							<span className="desc">Landscapes, portraits, street, product, etc.</span>
						</span>
					</a>
				</SubMenuItem>
				<SubMenuItem>
					<a href="/use-cases/videography">
						<span className="icon">🎥</span>
						<span className="label-container">
							<span className="label">Videographers</span>
							<span className="desc">Wedding videos, music videos, promotional, etc.</span>
						</span>
					</a>
				</SubMenuItem>
			</MenuItem>
			<MenuItem value={'How it Works'} href="#">
				<SubMenuItem>
					<a href="/features/ui" title="Features: UI">
						<span className="icon">⚡</span>
						<span className="label-container">
							<span className="label">Lightning Fast UI</span>
							<span className="desc">High performance, from the ground up.</span>
						</span>
					</a>
				</SubMenuItem>
				<SubMenuItem>
					<a href="/features/ml">
						<span className="icon">🧠</span>
						<span className="label-container">
							<span className="label">ML-powered Automation</span>
							<span className="desc">Skip all of the busywork.</span>
						</span>
					</a>
				</SubMenuItem>
				<SubMenuItem>
					<a href="/features/collab">
						<span className="icon">💏</span>
						<span className="label-container">
							<span className="label">Collaboration</span>
							<span className="desc">Work together in real-time.</span>
						</span>
					</a>
				</SubMenuItem>
			</MenuItem>
			<MenuItem value={'Pricing'} href="/pricing"></MenuItem>
			<MenuItem value={'Company'} href="/about"></MenuItem>
			{
      /* </AnimateSharedLayout> */
    }
		</StyledHeaderNav>;
};
export const StyledSubMenuItem = /*#__PURE__*/styled(motion.div)({
  name: "StyledSubMenuItem",
  class: "s1ycdsrt"
});
const SubMenuItemVariants = {
  hidden: {
    x: 40,
    opacity: 0
  },
  visible: {
    x: 0,
    opacity: 1
  }
};
export const SubMenuItem = ({
  children,
  ...props
}) => {
  return <StyledSubMenuItem {...props} layout variants={SubMenuItemVariants} transition={spring}>
			{children}
		</StyledSubMenuItem>;
};

require("./HeaderNav.linaria.module.css!=!../../../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./HeaderNav.tsx");